export function processEventSelection(newValues: string[], currentSelected: string[]): string[] {
    const isAllSelected = currentSelected.includes('all');
    const willSelectAll = newValues.includes('all');

    if (willSelectAll && !isAllSelected) {
        // User selected "All Events" - switch to all
        return ['all'];
    } else if (isAllSelected && !willSelectAll) {
        // User deselected "All Events" - clear selection
        return [];
    } else if (isAllSelected && newValues.length > 1) {
        // User had "All Events" and clicked a specific event - switch to just that event
        return newValues.filter(v => v !== 'all');
    } else {
        // Standard multi-select
        return newValues;
    }
}
